import React from "react";

import { Svg } from "./Svg";

const Idahat = (props) => (
  <Svg
    {...props}
    width={props.width || 126}
    height={props.height}
    viewBox="0 0 126 242"
  >
    <path d="M63 0 L0 242 L126 242 Z" />
  </Svg>
);

export default Idahat;
